export default __webpack_public_path__ + "static/media/thumbnail4.a1ef4061.jpg";